
import {
	LoginWrapper,
	LeftSection,
	RightSection,
	LoginSection,
	Logo,
	Tagline,
} from "./styled";
import { Heading } from "../../../../../components/Heading";

import logo from "./../../../../../icons/logo-text.svg";
import tagline from "./../../../../../icons/tagline.svg";
import rightImg from "./../../../../../newui/features/Auth/assets/login-right-img.webp";
import { Button } from "../../../../../components/Button";
import { useAuthContext } from "../../context/AuthContextProvider";

export const VerifyEmail = ({ path: _path }) => {
	const { logoutUser } = useAuthContext();

	return (
		<LoginWrapper>
			<LeftSection>
				<a href="/">
					<Logo
						src={logo}
						alt="Procuracon Logo"
					/>
				</a>
				<Tagline
					src={tagline}
					alt="Build Possible"
				/>

				<LoginSection>
					<Heading marginBottom="50px">
						<span>Please Verify your email to login</span>
					</Heading>
					<p className="instructions">
						Please check your inbox to verify email. If you can't find
						verification link please check your spam.
					</p>
					<Button
						marginTop="12px"
						onClick={logoutUser}
						data-testid={"logout-button"}
					>
						<span className="px-4">Logout</span>
					</Button>
				</LoginSection>
			</LeftSection>
			<RightSection
				style={{ backgroundImage: `url(${rightImg})` }}
			></RightSection>
		</LoginWrapper>
	);
};

export default VerifyEmail;
